import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import axiosInstance from 'axiosConfig';
import { Toast } from 'components';
import { TOAST_TYPES_ENUM } from 'enums';
import { queryClient } from 'App';

interface DeleteUsedAssemblyMaterialType {
  uuid: string;
}

const useDeleteUsedAssemblyMaterial = (
  options?: UseMutationOptions<any, Error, DeleteUsedAssemblyMaterialType>
) => {
  return useMutation({
    ...options,
    mutationKey: ['deleteUsedAssemblyMaterial'],
    mutationFn: async ({ uuid }) => {
      return axiosInstance.delete(`/assembly-materials/used/${uuid}`).then((res) => res.data);
    },
    onMutate: (variables) => {
      Toast({
        message: 'Przetwarzanie usuwania materiału...',
        type: TOAST_TYPES_ENUM.LOADING,
        id: 'delete-used-assembly-material',
      });
      if (options && options.onMutate) {
        return options.onMutate(variables);
      }
    },
    onSuccess: (data, variables, context) => {
      Toast({
        message: 'Materiał został pomyślnie usunięty',
        type: TOAST_TYPES_ENUM.SUCCESS,
        id: 'delete-used-assembly-material',
      });
      queryClient.invalidateQueries({ queryKey: ['orderDetails'] });
      if (options && options.onSuccess) {
        options.onSuccess(data, variables, context);
      }
    },
    onError: (error, variables, context) => {
      Toast({
        message: 'Błąd podczas usuwania materiału',
        type: TOAST_TYPES_ENUM.ERROR,
        id: 'delete-used-assembly-material',
      });
      if (options && options.onError) {
        options.onError(error, variables, context);
      }
    },
  });
};

export default useDeleteUsedAssemblyMaterial;
